import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthCallback from "./components/AuthCallback";
import Navbar from "./components/Navbar";

import Login from "./pages/Login";
import OrderForm from "./pages/OrderForm";
import OrdersList from "./pages/OrdersList";
import OrderDetail from "./pages/OrderDetail";
import UserManagement from "./pages/UserManagement";
import CustomersList from "./pages/CustomersList";
import CustomerForm from "./pages/CustomerForm";

function RoleHome() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "salesperson") return <OrderForm />;
  return <OrdersList />;
}

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback with session_id in URL fragment BEFORE any other routing
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <NavbarShown />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <RoleHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/new"
          element={
            <ProtectedRoute roles={["salesperson", "coordinator"]}>
              <OrderForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <ProtectedRoute>
              <OrdersList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders/:id"
          element={
            <ProtectedRoute>
              <OrderDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute requireAdmin>
              <UserManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers"
          element={
            <ProtectedRoute>
              <CustomersList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers/new"
          element={
            <ProtectedRoute roles={["salesperson", "coordinator"]}>
              <CustomerForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers/:id"
          element={
            <ProtectedRoute>
              <CustomerForm />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

function NavbarShown() {
  const location = useLocation();
  if (location.pathname === "/login") return null;
  return <Navbar />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
